import { render, staticRenderFns } from "./CompanyFormsEscalated.vue?vue&type=template&id=0f6d2d99&scoped=true&"
import script from "./CompanyFormsEscalated.vue?vue&type=script&lang=js&"
export * from "./CompanyFormsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFormsEscalated.vue?vue&type=style&index=0&id=0f6d2d99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d2d99",
  null
  
)

export default component.exports